module.exports = __webpack_public_path__ + "img/2_178.2d7ab778.png";